import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MainLayout from "@/layouts/MainLayout";
import Hero from "@/components/pages/home/Hero";
import Services from "@/components/pages/home/Services";
import Testimonials from "@/components/pages/home/Testimonials";
import Pricing from "@/components/pages/home/Pricing";

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a hash in the URL (e.g., /#services)
    if (location.hash) {
      // Remove the # character to get the element id
      const id = location.hash.substring(1);
      const element = document.getElementById(id);
      
      if (element) {
        // Use setTimeout to ensure the page has fully loaded
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // If no hash, scroll to top
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <MainLayout
      title="Niumora - AI-Powered Business Solutions & Training"
      description="Transforming businesses through AI-powered solutions and training. We combine cutting-edge AI technology with expert guidance to help businesses innovate, automate, and grow."
      keywords="AI business solutions, AI training, UK AI company, AI automation, AI consulting, Niumora"
      ogType="website"
    >
      <Hero />
      <div id="services">
        <Services />
      </div>
      <Testimonials />
      <div id="pricing">
        <Pricing />
      </div>
    </MainLayout>
  );
};

export default Index;
